import { Box, HbTooltip, Text } from '@cdl/heartbeat-react';
import { effortToEmoji, effortToTooltip } from '../../utils/task.utils';

type Props = {
  effort?: string;
};

export const EffortColumn: React.FC<Props> = ({ effort }) => {
  return (
    <HbTooltip label={effortToTooltip(effort)} placement='top-start'>
      <Box float='left' position='relative'>
        <Text fontSize='xl'>{effortToEmoji(effort)}</Text>
      </Box>
    </HbTooltip>
  );
};
